<template>
  <div class="task-container" style="margin-bottom:10px;">
    <el-table v-loading="tableLoading" :data="tableDataAfter" :height="height" border style="width: 100%" :header-cell-style="rowStyle"
              :cell-style="rowStyle1">
      <el-table-column prop="id" label="ID" width="70"></el-table-column>
      <!--      <el-table-column prop="isStudy" label="ID" width="70"></el-table-column>-->
      <el-table-column prop="title" label="任务名称" width="200"></el-table-column>
      <el-table-column prop="diseaseName" label="随访疾病">
      </el-table-column>
      <el-table-column prop="finishNum" label="已随访">
        <template slot="header">
          <span>已随访</span>
          <el-tooltip
              effect="light"
              content="全部坐席随访完成、未成功、失访的人数"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="waitNum" label="待随访">
        <template slot="header">
          <span>待随访</span>
          <el-tooltip
              effect="light"
              content="该任务总人数-已随访"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="quotaNumberType" label="今日指标">
        <template slot="header">
          <span>今日指标</span>
          <el-tooltip
              effect="light"
              content="今日需要完成的总指标量"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="finishQuotaNumber" label="已完成指标">
        <template slot="header">
          <span>已完成指标</span>
          <el-tooltip
              effect="light"
              content="今日已完成的指标量"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="thisMonthCallAvg" label="本月平均时长">
        <template slot="header">
          <span>本月平均时长</span>
          <el-tooltip
              effect="light"
              content="我的本月随访有效时长 / 本月（完成+未成功+失访）人数"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.thisMonthCall |avgFollowTime(scope.row.thisMonthFinish) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="allFinish" label="累积完成">
        <template slot="header">
          <span>累积完成</span>
          <el-tooltip
              effect="light"
              content=" 我的随访完成的，不包含未成功和失访的"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="allCall" label="累积呼叫">
        <template slot="header">
          <span>累积呼叫</span>
          <el-tooltip
              effect="light"
              content="我的累积通话时长（秒）"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="lostNum" label="失访人数">
        <template slot="header">
          <span>失访人数</span>
          <el-tooltip
              effect="light"
              content="我的失访人数"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="lostRate" label="失访率">
        <template slot="header">
          <span>失访率</span>
          <el-tooltip
              effect="light"
              content="我的失访人数 /（随访完成+未成功+失访）人数"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="passRate" label="合格率">
        <template slot="header">
          <span>合格率</span>
          <el-tooltip
              effect="light"
              content="我的（随访完成+未成功+失访）人数中，被抽查合格的/（随访完成+未成功+失访）人数"
              placement="bottom"
          >
            <img src="./img/question.png" style="width:18px;margin: 0 0 -3px 5px;"/>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="250">
        <template slot-scope="scope">
          <div :class="{'dot-container': true,'active': scope.row.isStudy}">
            <el-button size="mini" style="font-size: 15px" @click="studyHandler(scope.row,1)" type="text">学习
            </el-button>
          </div>
          <div :class="{'dot-container': true,'active': scope.row.isStudy}">
            <el-button size="mini" style="font-size: 15px" @click="mistakeClick(scope.row,1)" type="text">错题
            </el-button>
          </div>
          <el-button size="mini" style="font-size: 15px" @click="studyHandler(scope.row,2)" type="text">预览
          </el-button>
          <el-button  size="mini"
                      :style="{'fontSize': '15px','color':scope.row.isFollowup == 1 ?'#67c23a' : '#67c23a'}" type="text"
                      v-if="scope.row.status == 2" @click="startWorkHandle(scope.row)">开始
          </el-button>
          <el-button size="mini" style="font-size: 15px" type="text" @click="openDetail(scope.row)">详情</el-button>
          <el-button size="mini" style="font-size: 15px" type="text" v-if="scope.row.status == 4"
                     @click="startWorkHandle(scope.row)">历史
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 其他 -->
    <div v-if="this.taskDialogVisible">
      <el-dialog :visible.sync="taskDialogVisible" width="40%">
        <taskDetailDialog ref="taskDetailDialog" :taskInfo="taskDialogData"></taskDetailDialog>
      </el-dialog>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import {mapGetters, mapMutations, mapState} from "vuex";
import {RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId} from "@src/assets/js/api.js";
import taskDetailDialog from "../pages/components/workTable/taskDetailDialog.vue";

export default {
  name: "task-container",
  data() {
    return {
      height: window.innerHeight - 60 - 60 - 150 - 35,
      tableDataAfter: [],
      taskDialogVisible: false,
      taskDialogData: {},
      tableLoading:false
    };
  },
  props: {
    tableData: {
      type: Array,
    },
    taskInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters(["userid", "questionId"]),
  },
  watch: {
    tableData: {
      handler(val,oldVal) {
        console.log(oldVal,val);
        if(val) {
          this.tableDataAfter = JSON.parse(JSON.stringify(val))
          this.tableDataAfter.map(item => {
            if (item.quotaType) {
              item.quotaNumberType = `${item.distributeQuotaNumber}（${item.quotaType}）`
            }else {
              item.quotaNumberType = item.distributeQuotaNumber
            }
            return item
          })
          this.getTaskIdsWidhStudy()
              .then(res => {
                if(res.status == 0) {
                  this.tableDataAfter.forEach(item => {
                    if(res.retValue.find(it => item.id == it)) {
                      item['isStudy'] = true
                      this.$delete(item,'isStudy')
                      this.$set(item,'isStudy', true)
                    }
                  })
                }
              })
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {taskDetailDialog},
  filters: {
    formatTime: function (value) {
      if (!value) return "0分钟";
      if (value > 60) {
        return parseInt(value / 60) + "分" + (value % 60) + "秒";
      } else {
        return value + "秒";
      }
    },
    lostNumRate: function (value, power) {
      var Times = 0.0;
      if (power != 0) {
        Times = ((value / power) * 100).toFixed(2);
      }
      return Times;
    },
    formatTags: function (value, power) {
      var taskTags = [
        {label: "急", value: 1, power: 1, showPower: false},
        {
          label: "V",
          value: 2,
          power: 1,
          showPower: false,
        },
        {label: "重", value: 3, power: 1, showPower: false},
        {
          label: "密",
          value: 4,
          power: 1,
          showPower: false,
        },
        {label: "合", value: 5, power: 1, showPower: false},
        {
          label: "单",
          value: 6,
          power: 1,
          showPower: false,
        },
        {label: "难", value: 7, power: 1, showPower: false},
        {
          label: "免",
          value: 8,
          power: 1,
          showPower: false,
        },
      ];
      var str = ["+", "++", "+++"];
      var result = [];
      power = String(power);
      if (value) {
        value = String(value);
        for (var i = 0; i < value.length; i++) {
          var item = value[i];
          var p = power[i] > 3 ? 3 : power[i];
          var tag = taskTags.find((v, i) => {
            return v.value == item;
          });
          var rs = tag.label + str[p - 1];
          if (result.length == 0) {
            result.push(rs);
          } else {
            if (!rs.length < result[0].length) {
              result.unshift(rs);
            } else {
              result.push(rs);
            }
          }
        }
        return result.join(";");
      } else {
        return "暂无";
      }
    },
    formatfollowUpWay: function (value) {
      var text = "";
      switch (value) {
        case 11:
          text = "线上+电话";
          break;
        case 12:
          text = "电话";
          break;
        case 21:
          text = "线上";
          break;
        default:
          text = "未知";
          break;
      }
      return text;
    },
    formatSourceType: function (value) {
      var text = "";
      switch (value) {
        case 1:
          text = "医院";
          break;
        case 2:
          text = "公司";
          break;
        case 3:
          text = "荟医";
          break;
        default:
          text = "其他";
          break;
      }
      return text;
    },
    avgFollowTime: function (value, power) {
      var Times = 0.0;
      if (power != 0) {
        Times = (value / power).toFixed(2);
      }
      if (Times > 60) {
        return parseInt(Times / 60) + "分钟" + (Times % 60).toFixed(2) + "秒";
      } else {
        return Times + "秒";
      }
    },
  },
  methods: {
    ...mapMutations(["setTaskCenterId", "setTaskType", "setTaskTitle", "setQuestion"]),
    rowStyle({row, rowIndex}) {
      if (rowIndex == 0) {
        return 'color:#000;background:rgba(136, 136 ,136,0.25);border-color:rgb(230,230,230);cursor:pointer;font-size:17px'
      }
    }, rowStyle1({row, rowIndex}) {
      return 'color:#000;font-size:15px'

    },
    mistakeClick(taskInfo) {
      let query = `taskId=${taskInfo.id}`;
      this.$router.push("/wrongQuestionList?" + query);
    },
    studyHandler(taskInfo, type) {
      this.getFollowupTaskQuestionnaireNewId(taskInfo.id).then((res) => {
        if (res.status == 0) {
          this.setQuestion(res.retValue);
        }
      });
      localStorage.setItem("taskId", taskInfo.id);
      let query = `taskId=${taskInfo.id}&followUpWay=${taskInfo.followUpWay}&abnormal=100`;
      if (type == 1) {
        this.$router.push("/studyPage?" + query);
      } else {
        this.$router.push("/waitStudy?" + query);
      }
    },
    startWorkHandle(row) {
      // if(row.isStudy) {
      //   this.$message.error('请先前往查看学习材料')
      //   return
      // }
      this.setTaskCenterId(row.id);
      this.setTaskType(row.callType);
      this.setTaskTitle(row.title);
      var id = row.copyQuestionnaireId.indexOf(",")
          ? row.copyQuestionnaireId.split(",")[0]
          : row.copyQuestionnaireId;
      this.getFollowupTaskQuestionnaireNewId(row.id).then((res) => {
        if (res.status == 0) {
          this.setQuestion(res.retValue);
        }
      });
      this.$router.push({
        path: "/taskDetail",
        query: {
          isOpen: row.isOpen,
          diseaseId: row.diseaseId,
          isFrontPage: 1,
          isRemindStudy: row.isRemindStudy,
          isSingleDuration: row.isSingleDuration,
          isTotalDuration: row.isTotalDuration,
        },
      });
      localStorage.setItem("taskId", row.id);
      localStorage.setItem('isFrontPage', 1)
    },
    async getFollowupTaskQuestionnaireNewId(id) {
      let request = new RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId();
      request.p_followupTaskId = id;
      await request.send();
      return request.result;
    },
    async getTaskIdsWidhStudy() {
      let ids = this.tableData.map(item => {
        console.log(item.id);
        return item.id
      })
      console.log(ids);
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupQuestionListServiceGetTaskIds',
        params: {
          seatId: sessionStorage.getItem('userid'),
          taskIds: ids
        }
      })
      return result
    },
    // =======详情=======
    openDetail(task){
      this.tableLoading= true
      // 查看更多
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestCallCenterOperationPlatformControllerGetTaskDataSeatCompareInfo',
            params: {
              seatId: this.userid,
              followUpTaskId: task.id
            }
          }
      ).then(res => {
        this.tableLoading= false
        this.taskDialogVisible = true
        this.taskDialogData = res.retValue
        this.taskDialogData.taskCompleteRateNum = (this.taskDialogData.taskCompleteRate.replace('%', ''))*1;
        // 处理中位数和平均通话时长
        this.taskDialogData.allTaskFollowupData.validTalkTimeMedianHandle = this.formatDuring(this.taskDialogData.allTaskFollowupData.validTalkTimeMedian*1000)
        this.taskDialogData.myTaskFollowupData.validTalkTimeMedianHandle = this.formatDuring(this.taskDialogData.myTaskFollowupData.validTalkTimeMedian*1000)
        this.taskDialogData.avgTaskFollowupData.validTalkTimeMedianHandle = this.formatDuring(this.taskDialogData.avgTaskFollowupData.validTalkTimeMedian*1000)

        this.taskDialogData.allTaskFollowupData.avgCompleteValidTimeHandle = this.formatDuring(this.taskDialogData.allTaskFollowupData.avgCompleteValidTime)
        this.taskDialogData.myTaskFollowupData.avgCompleteValidTimeHandle = this.formatDuring(this.taskDialogData.myTaskFollowupData.avgCompleteValidTime)
        this.taskDialogData.avgTaskFollowupData.avgCompleteValidTimeHandle = this.formatDuring(this.taskDialogData.avgTaskFollowupData.avgCompleteValidTime)

        this.taskDialogData.myTaskFollowupData.qualifiedRateNum = (this.taskDialogData.myTaskFollowupData.qualifiedRate.replace('%', ''))*1
        this.taskDialogData.avgTaskFollowupData.qualifiedRateNum = (this.taskDialogData.avgTaskFollowupData.qualifiedRate.replace('%', ''))*1
      })
    },
    // 时间处理
    formatDuring(mss) {
      mss = parseInt(mss/1000)
      if (!mss) return '0 s '
      if (mss > 60) {
        return parseInt(mss / 60) + ' min ' + (mss % 60).toFixed(0) + ' s '
      } else {
        return mss + ' s '
      }
    },
  },
  mounted() {

  },
};
</script>
<style>
.item-dot {
  margin-top: 10px;
  margin-right: 40px;
}
</style>
<style scoped lang="scss">
.dot-container {
  display: inline-block;
  margin-right: 10px;
  position: relative;
  &.active::before {
    content: '';
    width: 5px;
    height: 5px;
    background-color: red;
    position: absolute;
    border-radius: 10px;
    right: 0;
    top: 0;
  }
}
.no-data {
  p {
    margin: 40px 0 80px;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }

  display: table-cell;
  vertical-align: middle;
  text-align: center;
  width: 480px;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.16),
  0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 15px 15px 15px 20px;
  box-sizing: border-box;
  margin-top: 20px;
  margin-bottom: 20px;
}

.task-container {
  .singTask {
    width: 96%;
    margin: 0 auto;
  }

  .taskTitle {
    color: rgba(16, 16, 16, 100);
    font-size: 16px;
    border: 1px solid rgba(187, 187, 187, 0.5);
    border-bottom: 0;
    padding-left: 16px;
    height: 48px;
    line-height: 48px;
    display: flex;
    justify-content: flex-start;

    .label {
      color: rgba(191, 191, 191, 100);
      font-size: 16px;
      text-align: left;
      margin-right: 10px;
    }

    .value {
      color: rgba(54, 147, 255, 100);
      font-size: 16px;
      text-align: left;
    }
  }

  .taskInfo {
    width: 90%;
    display: flex;
    border-bottom: 1px solid rgba(187, 187, 187, 0.5);
    border-top: 1px solid rgba(187, 187, 187, 0.5);

    span {
      height: 48px;
      line-height: 48px;
      text-align: center;
      width: 10%;
      border-right: 1px solid rgba(187, 187, 187, 0.5);

      &:first-child {
        border-left: 1px solid rgba(187, 187, 187, 0.5);
      }
    }
  }
}
</style>
